import { CrmApiRepository } from './crm/CrmApiRepository.js';
import { ClientsApiService } from './crm/ClientsApiService.js';
import { ContactService } from './ContactService.js';

export class AccountContactService {
    static async getAll() {
        const contacts = await CrmApiRepository.getAllContacts();
        return contacts
            .filter(c => c.clientId)
            .map(c => ({
                id: `${c.clientId}-${c.id}`,
                accountId: c.clientId,
                contactId: c.id,
                isPrimary: false,
                role: ''
            }));
    }

    static async getContactsForAccount(accountId, primaryContactId = null) {
        const contacts = await CrmApiRepository.getAllContacts(accountId);
        return contacts.map(c => ({ ...c, isPrimary: primaryContactId ? c.id === primaryContactId : false }));
    }

    static async getAccountsForContact(contactId) {
        const contact = await ContactService.getById(contactId);
        if (!contact?.clientId) return [];
        return [{ accountId: contact.clientId, contactId, isPrimary: true }];
    }

    static async getLinksForContact(contactId) {
        const contact = await ContactService.getById(contactId);
        if (!contact?.clientId) return [];
        return [{
            accountId: contact.clientId,
            contactId,
            isPrimary: false,
            role: ''
        }];
    }

    static async syncAccountsForContact(contactId, accountIds) {
        if (!accountIds.length) return;
        const contact = await ContactService.getById(contactId);
        if (!contact) return;
        const primaryAccountId = accountIds[0];
        if (contact.clientId !== primaryAccountId) {
            await ContactService.save({ ...contact, clientId: primaryAccountId }, primaryAccountId);
        }
    }

    static async link(accountId, contactId, options = {}) {
        const contact = await ContactService.getById(contactId);
        if (!contact) return null;
        const updated = await ContactService.save({ ...contact, clientId: accountId }, accountId);
        if (options.isPrimary) {
            await AccountContactService.setPrimary(accountId, contactId);
        }
        return updated;
    }

    static async unlink(accountId, contactId) {
        return AccountContactService.unlinkContact(accountId, contactId);
    }

    static async linkContact(accountId, contactId) {
        const contact = await ContactService.getById(contactId);
        if (!contact) return null;
        return ContactService.save({ ...contact, clientId: accountId }, accountId);
    }

    static async unlinkContact(accountId, contactId) {
        const contact = await ContactService.getById(contactId);
        if (!contact || contact.clientId !== accountId) return;
        return ContactService.save({ ...contact, clientId: null }, null);
    }

    static async setPrimary(accountId, contactId) {
        await ClientsApiService.update(accountId, { primary_contact_id: contactId });
    }

    static async syncLinksForContact() {
        return null;
    }

    static async removeAllForContact() {
        return null;
    }

    static async removeAllForAccount() {
        return null;
    }
}
